import { Input, InputRef } from 'antd';
import { RiSearch2Line } from 'react-icons/ri';
import { useRef } from 'react';

interface SearchContactInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  suffix?: React.ReactNode;
  autoFocus?: boolean;
}

export const SearchContactInput = ({
  value,
  onChange,
  placeholder = 'Search by name or phone number',
  error,
  suffix,
  autoFocus = true,
}: SearchContactInputProps) => {
  const inputRef = useRef<InputRef>(null);

  return (
    <Input
      ref={inputRef}
      size="large"
      placeholder={placeholder}
      prefix={<RiSearch2Line size={18} className="text-gray-700" />}
      suffix={suffix}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      status={error ? 'error' : ''}
      className="mb-2"
      autoFocus={autoFocus}
    />
  );
};
